import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI416_1 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "healthAndSafetyImpactAssessment",
      title:
        "a. What percentage of significant product and service categories undergo health and safety impact assessments for improvement?",
      fields: [
        {
          fieldName: "category",
          title: "Name of Category",
          type: "text",
          placeholder: "Type Here",
        },
        {
          fieldName: "percentage",
          title: "%",
          type: "percentage",
          placeholder: "Enter %",
        },
        {
          fieldName: "remarks",
          title: "Remark",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);
  const [data, setData] = useState({});

  const [tabErrors, setTabErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);

        const data1 = response.data.data.GRI400 || {};
        setData(data1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      // const isTableValid = validateTable(inputData, tables, setTabErrors);

      // if (!isTableValid) {
      //   return;
      // }

      let transformedData = restructureData(tables);

      const payload = {
        type: "GRI400",
        submitted416_1: true,
        ...transformedData,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/416-2/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/416-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p
        className={styles.section_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        416 : Customer Health & Safety
      </p>}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1.5rem" : "0" }}
      >
        416-1 : Assessment of the health and safeTy impacts of products and
        service categories
      </p>
      <Box>
        <Box>
          <DynamicTable
            inputData={inputData}
            tables={tables}
            data={data}
            setTables={setTables}
            errors={tabErrors}
            setErrors={setTabErrors}
            disabled={disabled}
            hide={hide}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI416_1;
